import { PropsWithChildren } from 'react'

import { styled } from 'styled-components'

type PageProps = PropsWithChildren<{
  variant?: 'centered' | 'full'
}>

const Page = ({ children, variant = 'centered' }: PageProps) => {
  const Content = variant === 'centered' ? CenteredContent : FullContent
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  )
}

export default Page

const Wrapper = styled.div`
  padding: 12px;
`

const CenteredContent = styled.div`
  margin: 0 auto;
  max-width: 800px;
  text-align: left;
`

const FullContent = styled.div``
